import React from 'react';
import { Box, Skeleton } from '@mui/material';

const PillarSkeleton = () => {
  return (
    <Box sx={{ px: 0, py: { xs: 1, sm: 2 } }}>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={200} height={32} animation="wave" />
        <Skeleton variant="text" width={340} height={18} animation="wave" sx={{ mt: 0.5 }} />
      </Box>

      {/* Table */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper', overflow: 'hidden' }}>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="text" width={80} height={20} animation="wave" />
          <Skeleton variant="text" width={60} height={16} animation="wave" />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, px: 2, py: 1, borderBottom: '2px solid', borderColor: 'divider' }}>
          {[70, 120, 80, 50].map((w, i) => (
            <Skeleton key={i} variant="text" width={w} height={14} animation="wave" />
          ))}
        </Box>
        {Array.from({ length: 4 }).map((_, i) => (
          <Box key={i} sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1.25,
            borderBottom: i < 3 ? '1px solid' : 'none', borderColor: 'divider',
          }}>
            <Skeleton variant="text" width={70} height={18} animation="wave" />
            <Skeleton variant="text" width={120} height={18} animation="wave" sx={{ flex: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Skeleton variant="text" width={45} height={18} animation="wave" />
              <Skeleton variant="rounded" width={40} height={4} animation="wave" sx={{ borderRadius: 2 }} />
            </Box>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PillarSkeleton;

